import { html } from 'fxjs/es';
import { MP_MAIL_ORDER_SALES } from '../../../../../Mp/Address/S/Constant/address.js';
import { MpAddressConstantS } from '../../../../../Mp/Address/S/Constant/module/MpAddressConstantS.js';
import { OMPCoreAtomTmplS } from '../../../Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';

const makeFooterKrHtml = () => {
  return html`
    <div class="omp-footer">
      <div class="omp-footer__logo">
        <a class="omp-footer__logo-a" href="/${TT.lang}/">
          <img
            class="omp-footer__logo-img"
            src="//s3.marpple.co/files/u_218933/2023/7/original/f01a70531eac8ab8ced3654146a153db12da80a91.svg"
            alt="MARPPLE"
          />
        </a>
      </div>
      <div class="omp-footer__customer">
        <div class="omp-footer__contact-us">
          <span class="title">고객센터</span>
          <div class="content">평일 10:00 ~ 18:00 (주말/공휴일 휴무)</div>
          <div class="email">
            <a class="email-a" href="mailto:help@marpple.com"><u>help@marpple.com</u></a>
          </div>
        </div>
        <div class="omp-footer__buttons">
          <div class="omp-footer__call omp-footer__button">
            <a class="omp-footer__button-a" href="tel:1566-9437">1566-9437</a>
          </div>
        </div>
      </div>
      <div class="omp-footer__divider"></div>
      <div class="omp-footer__footer-menus">
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            About
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/about">마플에 처음 오셨나요?</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="https://www.marpple.com/${T.lang}/customstore" target="_blank">커스텀 스토어 성수</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/event/list">이벤트</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a
                href="https://updatenote.marpplecorp.com/c6e12542-33da-4818-8f24-5f767e5c8a2a"
                target="_blank"
                >업데이트 노트</a
              >
            </li>
          </ul>
        </div>
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            Help
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/help-center/order-pay-kr">주문/결제 안내</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/help-center/make-group-kr">단체/대량 안내</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/help-center/image-edit-kr">제작/디자인 안내</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="omp-footer__company-info" data-open="false">
        <div class="omp-footer__company-info-title">
          <span>(주)마플코퍼레이션 사업자 정보</span>
          <span class="omp-footer__footer-menu-title-icon"
            >${OMPCoreAtomTmplS.arrowIcon({ direction: 'down' })}</span
          >
        </div>
        <div class="omp-footer__company-info-cont">
          <div>대표 박혜윤</div>
          <div>
            <span
              >사업자등록번호 105-88-13322<a
                href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1058813322&apv_perm_no="
                class="omp-footer__ftc"
                target="_blank"
                ><u>사업자정보 확인</u></a
              ></span
            >
          </div>
          <div>
            <span>통신판매업신고 ${MP_MAIL_ORDER_SALES}</span>
          </div>
          <div>
            <span>개인정보보호책임자 유인동</span>
          </div>
          <div>${MpAddressConstantS.MP_ADDRESS}</div>
          <div class="omp-footer__company-info-info-fax">
            <span class="omp-footer__bar"
              >이메일<a href="mailto:help@marpple.com" class="omp-footer__mail">help@marpple.com</a></span
            ><span>팩스 02-6486-9437</span>
          </div>
        </div>
        <div class="omp-footer__terms-wrapper">
          <div class="omp-footer__terms">
            <span>
              <a href="https://www.marpplecorp.com/" target="_blank">마플코퍼레이션</a>
            </span>
            <span>
              <a href="https://marpple.shop/${TT.lang}" target="_blank">마플샵</a>
            </span>
            <span>
              <a class="privacy" href="/${TT.lang}/privacy">개인정보취급방침</a>
            </span>
            <span>
              <a href="/${TT.lang}/terms">이용약관</a>
            </span>
          </div>
        </div>
      </div>
      <div class="omp-footer__logos">
        <div class="omp-footer__for-the-planet">
          <a href="https://www.onepercentfortheplaneTT.org/" target="_blank">
            <img
              class="don_lazy omp-footer__for-the-planet-img"
              data-src="//s3.marpple.co/files/u_218933/2023/7/original/c1a461770a27a6973657c228591ac9b8aa13754b1.png"
              alt="1% FOR THE PLANET"
            />
          </a>
        </div>
        <div class="omp-footer__iflogo">
          <a href="https://ifdesign.com/en/winner-ranking/project/marpple/206874?q=marpple" target="_blank">
            <img
              class="don_lazy omp-footer__iflogo-img"
              data-src="//s3.marpple.co/files/u_218933/2023/7/original/6328ef8c9ceefb81f3bcc02680d79bdedbf292cf1.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="omp-footer__copyright">
        <span>&copy; ${new Date().getFullYear()} Marpple Corp. All rights reserved.</span>
      </div>
    </div>
  `;
};

const makeFooterEnHtml = () => {
  return html`
    <div class="omp-footer">
      <div class="omp-footer__logo">
        <a class="omp-footer__logo-a" href="/${TT.lang}/">
          <img
            class="omp-footer__logo-img"
            src="//s3.marpple.co/files/u_218933/2023/7/original/f01a70531eac8ab8ced3654146a153db12da80a91.svg"
            alt="MARPPLE"
          />
        </a>
      </div>
      <div class="omp-footer__customer">
        <div class="omp-footer__contact-us">
          <span class="title">Get in Touch</span>
          <div class="content">
            Please use the 1:1 chat at the bottom right or contact us at
            <a class="email-a" href="mailto:cs@marpple.com">cs@marpple.com</a>
          </div>
        </div>
        <div class="omp-footer__buttons">
          <div class="omp-footer__call omp-footer__button">
            <a class="omp-footer__button-a" href="mailto:cs@marpple.com">Email Us</a>
          </div>
        </div>
      </div>
      <div class="omp-footer__divider"></div>
      <div class="omp-footer__footer-menus">
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            About
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/about">About Us</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="https://www.marpple.com/${T.lang}/customstore" target="_blank">Marpple Custom Store</a>
            </li>
          </ul>
        </div>
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            Help
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${T.lang}/help-center/buying-shipping">Buying & Shipping FAQ</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${T.lang}/help-center/creating-selling">Creating & Selling FAQ</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/contact_us">Contact Us</a>
            </li>
          </ul>
        </div>
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            Guideline
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/guideline/images">Image Guideline</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/guideline/copyright">Copyright Guideline</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="omp-footer__company-info" data-open="false">
        <div class="omp-footer__company-info-title">
          <span>Marpple Corp.</span>
          <span class="omp-footer__footer-menu-title-icon"
            >${OMPCoreAtomTmplS.arrowIcon({ direction: 'down' })}</span
          >
        </div>
        <div class="omp-footer__company-info-cont">
          <div>CEO Hyeyun Park</div>
          <div>
            <span
              >Business registration number 105-88-13322<a
                href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1058813322&apv_perm_no="
                class="omp-footer__ftc"
                target="_blank"
                ><u>View</u></a
              ></span
            >
          </div>
          <div>${MpAddressConstantS.MP_ADDRESS}</div>
          <div>
            <span>Privacy Protection Officer Indong Yoo</span>
          </div>
        </div>
        <div class="omp-footer__terms-wrapper">
          <div class="omp-footer__terms">
            <span>
              <a href="https://www.marpplecorp.com/" target="_blank">Marpple Corporation</a>
            </span>
            <span>
              <a href="https://marpple.shop/${TT.lang}" target="_blank">MarppleShop</a>
            </span>
          </div>
          <div class="omp-footer__terms">
            <span>
              <a class="privacy" href="/${TT.lang}/privacy">Privacy Policy</a>
            </span>
            <span>
              <a href="/${TT.lang}/terms">Terms & Conditions</a>
            </span>
          </div>
        </div>
        <div class="omp-footer__logos">
          <div class="omp-footer__for-the-planet">
            <a href="https://www.onepercentfortheplaneTT.org/" target="_blank">
              <img
                class="don_lazy omp-footer__for-the-planet-img"
                data-src="//s3.marpple.co/files/u_218933/2023/7/original/c1a461770a27a6973657c228591ac9b8aa13754b1.png"
                alt="1% FOR THE PLANET"
              />
            </a>
          </div>
          <div class="omp-footer__iflogo">
            <a href="https://ifdesign.com/en/winner-ranking/project/marpple/206874?q=marpple" target="_blank">
              <img
                class="don_lazy omp-footer__iflogo-img"
                data-src="//s3.marpple.co/files/u_218933/2023/7/original/6328ef8c9ceefb81f3bcc02680d79bdedbf292cf1.png"
                alt=""
              />
            </a>
          </div>
        </div>
        <div class="omp-footer__copyright">
          <span>&copy; ${new Date().getFullYear()} Marpple Corp. All rights reserved.</span>
        </div>
      </div>
    </div>
  `;
};

const makeFooterJpHtml = () => {
  return html`
    <div class="omp-footer">
      <div class="omp-footer__logo">
        <a class="omp-footer__logo-a" href="/${TT.lang}/">
          <img
            class="omp-footer__logo-img"
            src="//s3.marpple.co/files/u_218933/2023/7/original/f01a70531eac8ab8ced3654146a153db12da80a91.svg"
            alt="MARPPLE"
          />
        </a>
      </div>
      <div class="omp-footer__customer">
        <div class="omp-footer__contact-us">
          <span class="title">カスタマーサービス</span>
          <div class="content">
            画面右下の1:1チャットをご利用いただくか、
            <br />
            <a class="email-a" href="mailto:cs@marpple.com">cs@marpple.com</a>
            までご連絡ください。
          </div>
        </div>
        <div class="omp-footer__buttons">
          <div class="omp-footer__call omp-footer__button">
            <a class="omp-footer__button-a" href="mailto:cs@marpple.com">Email Us</a>
          </div>
        </div>
      </div>
      <div class="omp-footer__divider"></div>
      <div class="omp-footer__footer-menus">
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            About
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/about">Marppleとは</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="https://www.marpple.com/${T.lang}/customstore" target="_blank"
                >Marpple カスタムストア</a
              >
            </li>
          </ul>
        </div>
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            Help
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${T.lang}/help-center/buying-shipping">注文・決済について</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${T.lang}/help-center/creating-selling">製作・製作過程について</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${T.lang}/help-center/image-edit-jp">製作・イメージ・プリントについて</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/contact_us">お問い合わせ</a>
            </li>
          </ul>
        </div>
        <div class="omp-footer__footer-menu" data-open="true">
          <div class="omp-footer__footer-menu-title">
            Guideline
            <span class="omp-footer__footer-menu-title-icon"
              >${OMPCoreAtomTmplS.arrowIcon({ direction: 'up' })}</span
            >
          </div>
          <ul class="omp-footer__footer-menu-ul">
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/guideline/images">イメージガイドライン</a>
            </li>
            <li class="omp-footer__footer-menu-li">
              <a href="/${TT.lang}/guideline/copyright">著作権ガイドライン</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="omp-footer__company-info" data-open="false">
        <div class="omp-footer__company-info-title">
          <span>Marpple Corp.</span>
          <span class="omp-footer__footer-menu-title-icon"
            >${OMPCoreAtomTmplS.arrowIcon({ direction: 'down' })}</span
          >
        </div>
        <div class="omp-footer__company-info-cont">
          <div>CEO Hyeyun Park</div>
          <div>
            <span
              >事業者登録番号 105-88-13322<a
                href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1058813322&apv_perm_no="
                class="omp-footer__ftc"
                target="_blank"
                ><u>事業者情報を見る</u></a
              ></span
            >
          </div>
          <div>${MpAddressConstantS.MP_ADDRESS_JP}</div>
          <div>
            <span>個人情報保護責任者 Indong Yoo</span>
          </div>
        </div>
        <div class="omp-footer__terms-wrapper">
          <div class="omp-footer__terms">
            <span>
              <a href="https://www.marpplecorp.com/" target="_blank">Marpple Corporation</a>
            </span>
            <span>
              <a href="https://marpple.shop/${TT.lang}" target="_blank">MarppleShop</a>
            </span>
          </div>
          <div class="omp-footer__terms">
            <span>
              <a class="privacy" href="/${TT.lang}/privacy">プライバシーポリシー</a>
            </span>
            <span>
              <a href="/${TT.lang}/terms">利用規約</a>
            </span>
          </div>
        </div>
      </div>
      <div class="omp-footer__logos">
        <div class="omp-footer__for-the-planet">
          <a href="https://www.onepercentfortheplaneTT.org/" target="_blank">
            <img
              class="don_lazy omp-footer__for-the-planet-img"
              data-src="//s3.marpple.co/files/u_218933/2023/7/original/c1a461770a27a6973657c228591ac9b8aa13754b1.png"
              alt="1% FOR THE PLANET"
            />
          </a>
        </div>
        <div class="omp-footer__iflogo">
          <a href="https://ifdesign.com/en/winner-ranking/project/marpple/206874?q=marpple" target="_blank">
            <img
              class="don_lazy omp-footer__iflogo-img"
              data-src="//s3.marpple.co/files/u_218933/2023/7/original/6328ef8c9ceefb81f3bcc02680d79bdedbf292cf1.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="omp-footer__copyright">
        <span>&copy; ${new Date().getFullYear()} Marpple Corp. All rights reserved.</span>
      </div>
    </div>
  `;
};

const makeMpFooterHTML = () => {
  if (TT.lang == 'kr') return makeFooterKrHtml();
  if (TT.lang == 'en') return makeFooterEnHtml();
  if (TT.lang == 'jp') return makeFooterJpHtml();
};

export const footerMobileHTML = makeMpFooterHTML;
